/* Ripped Lab — Meal Plan Solver (Φάση 2, v2 — global optimization)
   Υλοποιεί το Reference Manual §8-13: ρόλους τροφών (§9.14), locked κανόνες (§9.1-9.8),
   ισοκατανομή πρωτεΐνης (§9.9) ΜΕ global εξισορρόπηση ημέρας, λιπαρά §9.6 με αυτόματη
   προσθήκη healthy fats, εξαίρεση whey §9.7 (με ρητό flag), κατανομή υδατανθράκων §9.15,
   feasibility §9.11, σύγκρουση κανόνων §9.12, containers §10.1, όρια §11 (±25 kcal, ±3g P/F).
   Ο σολομός §9.1 επιλέγεται global: δοκιμάζονται 125/250 και κρατιέται το καλύτερο πλάνο.
   Όλα client-side. Εκτίθεται ως window.RLPlan για tests & UI. */
(function () {
  'use strict';

  /* ---------- Βάση τροφών (από Calories_Food_Categories.xlsx) ---------- */
  /* role: main | tier2 | secondary | carb | fat | veg | extra | container
     όρια ανά γεύμα σε g εκτός αν type=container (μονάδες) */
  var FOODS = {
    'Κοτόπουλο Στήθος':      { kcal:109, p:20.0, c:0,    f:1.4,  role:'main',      min:200, max:400 },
    'Μοσχάρι Φιλέτο':        { kcal:121, p:22.0, c:0,    f:3.0,  role:'main',      min:200, max:400 },
    'Γαλοπουλα':             { kcal:93,  p:13.0, c:4.5,  f:2.5,  role:'main',      min:200, max:400 },
    'Σολωμός':               { kcal:197, p:19.4, c:0,    f:13.3, role:'main',      locked:[125,250] },
    'Τόνος':                 { kcal:101, p:24.0, c:0,    f:0.5,  role:'main',      min:100, max:300 },
    'Γαρίδες':               { kcal:97,  p:20.3, c:0,    f:1.7,  role:'main',      min:150, max:400 },
    'Συκώτι':                { kcal:139, p:20.4, c:1.7,  f:5.0,  role:'main',      min:150, max:300 },
    'Φακές':                 { kcal:298, p:24.0, c:31.0, f:2.0,  role:'main',      minM:80, minF:60, max:200 },
    'Ρεβύθια':               { kcal:346, p:21.0, c:42.0, f:6.6,  role:'main',      minM:80, minF:60, max:200 },
    'Φασόλια Χάντρες':       { kcal:343, p:23.0, c:60.0, f:1.2,  role:'main',      minM:80, minF:60, max:200 },
    'Chicken Fingers':       { kcal:190, p:17.5, c:13.3, f:7.4,  role:'main',      min:100, max:300 },
    'Fish Fillet':           { kcal:216, p:12.0, c:21.0, f:9.1,  role:'main',      min:100, max:300 },
    'Φέτα Ήπειρος Slim':     { kcal:140, p:21.0, c:0.4,  f:6.0,  role:'tier2',     min:30,  max:120 },
    'Μοτσαρέλα':             { kcal:247, p:18.0, c:7.0,  f:19.0, role:'tier2',     min:30,  max:125 },
    'Τυρί Νουνού Light':     { kcal:235, p:31.0, c:0,    f:11.3, role:'tier2',     min:30,  max:100 },
    'Ταλαγάνι':              { kcal:317, p:18.0, c:2.7,  f:26.0, role:'tier2',     min:30,  max:100 },
    'Γιαούρτι Νουνου 1.5%':  { kcal:72,  p:10.3, c:4.3,  f:1.5,  role:'secondary', min:100, ideal:300, max:450 },
    'Αυγά Ασπράδι':          { kcal:55,  p:10.9, c:1.0,  f:0,    role:'secondary', min:66,  max:300 },
    'Πρωτεϊνη Whey Isolate MP': { kcal:373, p:90.0, c:2.5, f:0.1, role:'secondary', min:15, max:45, wheyCap:true },
    'Cottage 4%':            { kcal:100, p:12.0, c:2.4,  f:4.0,  role:'secondary', min:100, max:300 },
    'Γάλα Light':            { kcal:46,  p:3.3,  c:4.7,  f:1.5,  role:'secondary', min:100, max:300 },
    'Ενταμάμε Φασόλια':      { kcal:135, p:12.0, c:13.0, f:3.6,  role:'secondary', min:50,  max:250 },
    'Βρώμη':                 { kcal:372, p:13.5, c:58.7, f:7.0,  role:'carb', min:20, max:150 },
    'Ρύζι Μπασμάτι':         { kcal:132, p:3.1,  c:29.1, f:0.2,  role:'carb', min:50, max:400 },
    'Πατάτα':                { kcal:93,  p:2.5,  c:21.1, f:0.1,  role:'carb', min:100, max:500 },
    'Γλυκοπατάτα':           { kcal:91,  p:1.5,  c:20.7, f:0.1,  role:'carb', min:100, max:500 },
    'Μακαρόνια Fitness':     { kcal:359, p:18.1, c:65.6, f:2.0,  role:'carb', min:40, max:200 },
    'Ψωμί Τόστ':             { kcal:262, p:9.2,  c:48.3, f:3.0,  role:'carb', min:25, max:120 },
    'Τορτίγια Ολικής':       { kcal:301, p:9.7,  c:53.0, f:7.6,  role:'carb', min:40, max:120 },
    'Κινοα':                 { kcal:368, p:14.0, c:57.0, f:6.1,  role:'carb', min:40, max:200 },
    'Egg Noodles':           { kcal:317, p:10.1, c:62.3, f:2.4,  role:'carb', min:40, max:200 },
    'Νιοκι Πατατας':         { kcal:155, p:3.3,  c:32.0, f:1.0,  role:'carb', min:80, max:350 },
    'Φοκάτσια':              { kcal:243, p:7.1,  c:45.7, f:2.7,  role:'carb', min:40, max:150 },
    'Ποπ Κορν':              { kcal:365, p:9.4,  c:74.3, f:4.7,  role:'carb', min:10, max:60 },
    'Κρακερς':               { kcal:425, p:9.0,  c:68.7, f:11.5, role:'carb', min:10, max:60 },
    'Χουρμάδες':             { kcal:273, p:1.0,  c:75.6, f:0,    role:'carb', min:8,  max:60, fast:true, piece:8 },
    'Μπανάνα':               { kcal:93,  p:0.8,  c:22.9, f:0,    role:'carb', min:60, max:240, fast:true, piece:120 },
    'Μήλο':                  { kcal:61,  p:0.4,  c:14.8, f:0.2,  role:'carb', min:90, max:360, fast:true, piece:180 },
    'Μέλι':                  { kcal:302, p:0,    c:86.4, f:0,    role:'carb', min:5,  max:40, fast:true },
    'Ελαιόλαδο':             { kcal:804, p:0,    c:0,    f:93.8, role:'fat', min:3,  max:40, explicit:true },
    'Καρύδια':               { kcal:734, p:17.2, c:15.5, f:73.6, role:'fat', min:5,  max:50, piece:5, autoAdd:1 },
    'Αμύγδαλα':              { kcal:657, p:22.0, c:19.0, f:53.0, role:'fat', min:5,  max:50, autoAdd:2 },
    'Φυστικοβούτυρο':        { kcal:608, p:23.0, c:14.7, f:48.5, role:'fat', min:5,  max:50 },
    'Αυγά Κρόκος':           { kcal:328, p:16.2, c:1.02, f:28.8, role:'fat', min:15, max:30, dayCap:30, piece:15 },
    'Σπόροι Τσία':           { kcal:500, p:16.7, c:33.3, f:33.3, role:'fat', min:5,  max:30 },
    'Αβοκάντο':              { kcal:160, p:2.0,  c:8.5,  f:14.7, role:'fat', min:30, max:150, piece:150 },
    'Κασιους':               { kcal:595, p:18.0, c:30.0, f:44.0, role:'fat', min:5,  max:50 },
    'Κουκουνάρι':            { kcal:727, p:14.0, c:13.0, f:68.0, role:'fat', min:5,  max:30 },
    'Σπόροι Κακάο':          { kcal:583, p:12.8, c:35.1, f:43.5, role:'fat', min:5,  max:30 },
    'Μπρόκολο':              { kcal:29,  p:3.1,  c:5.4,  f:0.3,  role:'veg', min:50, max:400 },
    'Ντοματίνια':            { kcal:18,  p:0.9,  c:3.9,  f:0.2,  role:'veg', min:50, max:300 },
    'Αγγούρι':               { kcal:15,  p:1.0,  c:1.2,  f:0.6,  role:'veg', min:50, max:300 },
    'Μανιτάρια White':       { kcal:25,  p:3.0,  c:3.0,  f:0,    role:'veg', min:50, max:300 },
    'Πιπεριά Κόκκινη':       { kcal:26,  p:0.8,  c:6.2,  f:0,    role:'veg', min:50, max:300 },
    'Πιπεριά Πράσινη':       { kcal:22,  p:0,    c:4.4,  f:0.8,  role:'veg', min:50, max:300 },
    'Κρεμμύδι Ξερό':         { kcal:38,  p:0.8,  c:8.4,  f:0,    role:'veg', min:20, max:150 },
    'Λαχανάκι Βρυξελών':     { kcal:43,  p:3.3,  c:8.9,  f:0.3,  role:'veg', min:50, max:300 },
    'Καρότο':                { kcal:35,  p:0.9,  c:9.6,  f:0.2,  role:'veg', min:50, max:300 },
    'Πατζάρι':               { kcal:36,  p:1.7,  c:7.6,  f:0.1,  role:'veg', min:50, max:300 },
    'Baby Corn':             { kcal:60,  p:2.0,  c:11.2, f:0.8,  role:'veg', min:50, max:300 },
    'Τζίντζερ':              { kcal:80,  p:5.1,  c:17.8, f:0.7,  role:'veg', min:5,  max:30 },
    'Πέστο':                 { kcal:482, p:4.7,  c:9.8,  f:46.0, role:'extra', min:10, max:40 },
    'Siracha Mayo':          { kcal:465, p:11.0, c:0.5,  f:46.0, role:'extra', min:5,  max:30 },
    'Teriyaki':              { kcal:100, p:6.4,  c:12.0, f:0,    role:'extra', min:10, max:50 },
    'Κρεμα Γάλακτος Light':  { kcal:74,  p:3.3,  c:7.1,  f:3.5,  role:'extra', min:20, max:100 },
    'Ψύλλιο Husk':           { kcal:194, p:2.6,  c:0.2,  f:1.1,  role:'extra', min:5,  max:15 },
    'Kinder Σοκολατάκια':    { kcal:566, p:8.7,  c:53.5, f:35.0, role:'extra', min:10, max:40 },
    'Ninja Ice Cream':       { kcal:325.5, p:31.0, c:14.2, f:17.1, role:'container' },
    'Κεφίρ':                 { kcal:138,   p:8.8,  c:7.6,  f:8.0,  role:'container' },
    'Τσιπς Ρυζιού':          { kcal:124,   p:3.7,  c:22.0, f:1.9,  role:'container' },
    'Layered':               { kcal:211,   p:20.0, c:20.0, f:6.1,  role:'container' }
  };

  var R = Math.round;
  var WHEY_HARD_CAP = 90; /* §9.7.1 (03/09/2026): η εξαίρεση της §9.7 δεν ξεπερνά ποτέ τα 90g/γεύμα */
  function per100(food, grams) {
    return { kcal: food.kcal * grams / 100, p: food.p * grams / 100, c: food.c * grams / 100, f: food.f * grams / 100 };
  }
  function foodMin(fd, sex) {
    if (fd.min != null) return fd.min;
    return (sex === 'm' ? fd.minM : fd.minF) || 0; /* §9.13 φακές/όσπρια */
  }
  function mealHasRealMain(m) {
    return m.foods.some(function (o) { return FOODS[o.name].role === 'main'; });
  }
  /* Κύρια στο πλαίσιο του γεύματος: main πάντα, tier2 μόνο χωρίς άλλη κύρια (§9.14) */
  function actsAsMain(it, m) {
    var fd = FOODS[it.name];
    if (fd.role === 'main') return true;
    if (fd.role === 'tier2') return !mealHasRealMain(m);
    return false;
  }

  /* ---------- Συνολικά γεύματος/ημέρας ---------- */
  function mealTotals(m) {
    var t = { kcal: 0, p: 0, c: 0, f: 0 };
    m.foods.forEach(function (it) {
      var fd = FOODS[it.name];
      var v = fd.role === 'container'
        ? { kcal: fd.kcal * (it.units || 1), p: fd.p * (it.units || 1), c: fd.c * (it.units || 1), f: fd.f * (it.units || 1) }
        : per100(fd, it.grams || 0);
      t.kcal += v.kcal; t.p += v.p; t.c += v.c; t.f += v.f;
    });
    return t;
  }
  function dayTotals(meals) {
    var t = { kcal: 0, p: 0, c: 0, f: 0 };
    meals.forEach(function (m) {
      var v = mealTotals(m);
      t.kcal += v.kcal; t.p += v.p; t.c += v.c; t.f += v.f;
    });
    return t;
  }

  /* ---------- §9.9 Ισοκατανομή πρωτεΐνης ---------- */
  function allocateProtein(targetProtein, meals, sex) {
    var minPerMeal = sex === 'm' ? 30 : 20;
    var lockedP = 0, flexMeals = [];
    meals.forEach(function (m) {
      m.lockedP = 0;
      m.foods.forEach(function (it) {
        var fd = FOODS[it.name];
        if (fd.role === 'container') { m.lockedP += fd.p * (it.units || 1); }
        if (fd.locked) { it.grams = it.grams || fd.locked[0]; m.lockedP += fd.p * it.grams / 100; }
      });
      lockedP += m.lockedP;
      var onlyLocked = m.foods.every(function (it) {
        return FOODS[it.name].role === 'container' || FOODS[it.name].locked;
      });
      if (!onlyLocked) flexMeals.push(m);
    });
    var flexP = targetProtein - lockedP;
    var target = flexMeals.length ? flexP / flexMeals.length : 0;
    flexMeals.forEach(function (m) {
      m.hasMain = m.foods.some(function (it) { return actsAsMain(it, m) && !FOODS[it.name].locked; });
      m.pTarget = target;
      m.pTol = m.hasMain ? 15 : 5;
      m.pMin = minPerMeal;
    });
    return { lockedP: lockedP, flexTarget: target, flexMeals: flexMeals };
  }

  /* ---------- Γέμισμα πρωτεΐνης σε γεύμα (§9.14 calibration) ---------- */
  function fillMealProtein(m, sex) {
    var got = m.lockedP;
    /* παθητική πρωτεΐνη από carb/fat/veg τροφές του τρέχοντος iteration */
    m.foods.forEach(function (it) {
      var fd = FOODS[it.name];
      if (fd.role === 'carb' || fd.role === 'fat' || fd.role === 'veg' || fd.role === 'extra') got += fd.p * (it.grams || 0) / 100;
    });
    var mains = [], secs = [];
    m.foods.forEach(function (it) {
      var fd = FOODS[it.name];
      if (fd.locked || fd.role === 'container') return;
      if (actsAsMain(it, m)) mains.push(it);
      else if (fd.role === 'secondary' || fd.role === 'tier2') secs.push(it);
    });
    /* κύρια στο εύλογο μέγιστο πρώτα (§9.14) */
    mains.forEach(function (it) {
      var fd = FOODS[it.name];
      var min = foodMin(fd, sex);
      var need = (m.pTarget - got) / (fd.p / 100);
      it.grams = Math.max(min, Math.min(fd.max, R(need)));
      got += fd.p * it.grams / 100;
    });
    secs.forEach(function (it) {
      var fd = FOODS[it.name];
      var idealMax = fd.ideal || fd.max;
      var need = (m.pTarget - got) / (fd.p / 100);
      it.grams = Math.max(0, Math.min(idealMax, R(need)));
      if (it.grams > 0 && it.grams < fd.min) it.grams = fd.min;
      got += fd.p * it.grams / 100;
    });
    m.proteinGot = got;
  }

  /* ---------- Σκάλα προτεραιότητας πρωτεΐνης για global εξισορρόπηση ----------
     Άνοδος: 1 κύριες→max (§9.14) · 2 tier2-συμπλήρωμα→max · 3 δευτερεύουσες→ideal/max
     (whey→45 §9.7) · 4 γιαούρτι 300→450 (§9.8.1, μόνο αφού εξαντληθούν τα άλλα) ·
     5 whey πέραν των 45g (§9.7 εξαίρεση, με ρητό flag). Κάθοδος: αντίστροφα. */
  function proteinLadder(meals, sex) {
    var up = [], down = [];
    meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        var fd = FOODS[it.name];
        if (fd.locked || fd.role === 'container') return;
        var min = foodMin(fd, sex);
        if (actsAsMain(it, m)) {
          up.push({ it: it, fd: fd, m: m, tier: 1, cap: fd.max });
          down.push({ it: it, fd: fd, m: m, tier: 5, floor: min });
        } else if (fd.role === 'tier2') {
          up.push({ it: it, fd: fd, m: m, tier: 2, cap: fd.max });
          down.push({ it: it, fd: fd, m: m, tier: 4, floor: min });
        } else if (fd.role === 'secondary') {
          var idealCap = fd.wheyCap ? 45 : (fd.ideal || fd.max);
          up.push({ it: it, fd: fd, m: m, tier: 3, cap: idealCap });
          down.push({ it: it, fd: fd, m: m, tier: 3, floor: 0, minIfUsed: fd.min });
          if (fd.ideal && fd.max > fd.ideal) {
            up.push({ it: it, fd: fd, m: m, tier: 4, cap: fd.max });
            down.push({ it: it, fd: fd, m: m, tier: 2, floor: fd.ideal });
          }
          if (fd.wheyCap) {
            up.push({ it: it, fd: fd, m: m, tier: 5, cap: WHEY_HARD_CAP, wheyException: true });
            down.push({ it: it, fd: fd, m: m, tier: 1, floor: 45 });
          }
        }
      });
    });
    up.sort(function (a, b) { return a.tier - b.tier; });
    down.sort(function (a, b) { return a.tier - b.tier; });
    return { up: up, down: down };
  }

  function balanceProteinDay(meals, targets, sex, issues) {
    var ladder = proteinLadder(meals, sex);
    var guard = 0;
    /* Άνοδος: έλλειμμα ημέρας */
    var diff = targets.p - dayTotals(meals).p;
    for (var i = 0; i < ladder.up.length && diff > 1 && guard < 400; i++, guard++) {
      var c = ladder.up[i];
      var cur = c.it.grams || 0;
      if (cur >= c.cap) continue;
      var needG = Math.ceil(diff / (c.fd.p / 100));
      var add = Math.min(needG, (c.cap === Infinity ? needG : c.cap - cur));
      if (cur === 0 && c.fd.min && cur + add < c.fd.min) add = c.fd.min;
      if (c.wheyException && cur + add > 45) {
        issues.push({ type: 'whey-exception', meal: c.m.name, grams: cur + add,
          note: '§9.7: υπέρβαση 45g whey — οι υπόλοιπες πηγές είναι στα λογικά maximums' });
        if (cur + add >= WHEY_HARD_CAP && diff - c.fd.p * add / 100 > 1) {
          issues.push({ type: 'whey-cap', meal: c.m.name, grams: WHEY_HARD_CAP,
            suggest: 'Η whey έφτασε το ταβάνι των ' + WHEY_HARD_CAP + 'g στο ' + c.m.name + ' (§9.7.1) — πρόσθεσε άλλη πηγή πρωτεΐνης στο γεύμα.' });
        }
      }
      c.it.grams = cur + add;
      diff -= c.fd.p * add / 100;
    }
    /* Κάθοδος: πλεόνασμα ημέρας — ποτέ γεύμα κάτω από το hard min §9.9,
       αλλιώς το enforceMealMinimums το ξαναγεμίζει και ο κύκλος δεν κλείνει */
    var minPerMeal = sex === 'm' ? 30 : 20;
    diff = dayTotals(meals).p - targets.p;
    for (var j = 0; j < ladder.down.length && diff > 1 && guard < 800; j++, guard++) {
      var d = ladder.down[j];
      var g = d.it.grams || 0;
      if (g <= d.floor) continue;
      var mealRoomP = mealTotals(d.m).p - minPerMeal;
      if (mealRoomP <= 0) continue;
      var cutG = Math.min(g - d.floor,
        Math.ceil(Math.min(diff, mealRoomP) / (d.fd.p / 100)));
      var ng = g - cutG;
      if (d.minIfUsed && ng > 0 && ng < d.minIfUsed) ng = (g - d.minIfUsed >= 0 && diff * 100 / d.fd.p > g - d.minIfUsed) ? 0 : d.minIfUsed;
      if (ng < d.floor) ng = d.floor;
      diff -= d.fd.p * (g - ng) / 100;
      d.it.grams = ng;
    }
  }

  /* Hard minimum πρωτεΐνης/γεύμα (§9.9): boost εντός γεύματος· αναφορά μόνο
     στο τέλος (report=true) ώστε τα νούμερα να είναι της τελικής κατάστασης */
  function enforceMealMinimums(meals, flexMeals, sex, issues, report) {
    var minPerMeal = sex === 'm' ? 30 : 20;
    flexMeals.forEach(function (m) {
      var t = mealTotals(m);
      if (t.p >= minPerMeal - 0.5) return;
      var lack = minPerMeal - t.p;
      m.foods.forEach(function (it) {
        if (lack <= 0) return;
        var fd = FOODS[it.name];
        if (fd.locked || fd.role === 'container') return;
        if (fd.role !== 'main' && fd.role !== 'tier2' && fd.role !== 'secondary') return;
        var cap = fd.wheyCap ? 45 : fd.max;
        var cur = it.grams || 0;
        if (cur >= cap) return;
        var add = Math.min(cap - cur, Math.ceil(lack / (fd.p / 100)));
        if (cur === 0 && fd.min && add < fd.min) add = fd.min;
        it.grams = cur + add;
        lack -= fd.p * add / 100;
      });
      var t2 = mealTotals(m);
      if (report && t2.p < minPerMeal - 0.5) {
        issues.push({ type: 'meal-under-min-protein', meal: m.name, got: R(t2.p), min: minPerMeal,
          suggest: 'Πρόσθεσε πρωτεϊνική τροφή στο γεύμα ή συγχώνευσέ το με άλλο (§9.9).' });
      }
    });
  }

  /* ---------- Λιπαρά §9.6: κρόκοι ≤30g/ημέρα → ελαιόλαδο → healthy fats (auto) ---------- */
  function solveFats(meals, fatTarget, issues) {
    var deficit = fatTarget - dayTotals(meals).f;
    var order = ['Αυγά Κρόκος', 'Ελαιόλαδο', 'Καρύδια', 'Αμύγδαλα', 'Φυστικοβούτυρο', 'Σπόροι Τσία'];
    var dayYolk = 0;
    meals.forEach(function (m) { m.foods.forEach(function (it) { if (it.name === 'Αυγά Κρόκος') dayYolk += it.grams || 0; }); });

    if (deficit > 3) {
      /* 1) γέμισε τις fat τροφές που υπάρχουν ήδη στα γεύματα */
      order.forEach(function (name) {
        if (deficit <= 3) return;
        meals.forEach(function (m) {
          if (deficit <= 3) return;
          var it = m.foods.find(function (x) { return x.name === name; });
          if (!it) return;
          var fd = FOODS[name];
          var room = fd.max - (it.grams || 0);
          if (name === 'Αυγά Κρόκος') room = Math.min(room, fd.dayCap - dayYolk);
          if (room <= 0) return;
          var addG = Math.min(room, Math.ceil(deficit / (fd.f / 100)));
          it.grams = (it.grams || 0) + addG;
          if (name === 'Αυγά Κρόκος') dayYolk += addG;
          deficit -= fd.f * addG / 100;
        });
      });
      /* 2) §9.6: αυτόματη προσθήκη healthy fats (καρύδια → αμύγδαλα), χωρίς prompt.
         Όχι στο Post-Workout shake (§9.15). */
      var autoNames = ['Καρύδια', 'Αμύγδαλα'];
      autoNames.forEach(function (name) {
        if (deficit <= 3) return;
        var fd = FOODS[name];
        meals.forEach(function (m) {
          if (deficit <= 3) return;
          if (/post[- ]?workout/i.test(m.name)) return;
          if (m.foods.some(function (x) { return x.name === name; })) return;
          if (m.foods.every(function (x) { return FOODS[x.name].role === 'container'; })) return;
          var addG = Math.min(fd.max, Math.max(fd.min, Math.ceil(deficit / (fd.f / 100))));
          m.foods.push({ name: name, grams: addG, auto: true });
          deficit -= fd.f * addG / 100;
          issues.push({ type: 'auto-fat-added', meal: m.name, food: name, grams: addG,
            note: '§9.6: αυτόματη συμπλήρωση λιπαρών' });
        });
      });
    } else if (deficit < -3) {
      /* Πλεόνασμα: μείωσε πρώτα ό,τι προστέθηκε/είναι καθαρή πηγή λίπους, αντίστροφα */
      var over = -deficit;
      var trimOrder = ['Σπόροι Τσία', 'Φυστικοβούτυρο', 'Αμύγδαλα', 'Καρύδια', 'Ελαιόλαδο', 'Αυγά Κρόκος'];
      trimOrder.forEach(function (name) {
        if (over <= 3) return;
        meals.forEach(function (m) {
          if (over <= 3) return;
          var idx = -1;
          m.foods.forEach(function (x, k) { if (x.name === name) idx = k; });
          if (idx < 0) return;
          var it = m.foods[idx];
          var fd = FOODS[name];
          var g = it.grams || 0;
          if (g <= 0) return;
          var cutG = Math.min(g, Math.ceil(over / (fd.f / 100)));
          var ng = g - cutG;
          if (ng > 0 && ng < fd.min) ng = 0; /* §9.4: το ελαιόλαδο ορίζεται για να βγουν τα macros */
          over -= fd.f * (g - ng) / 100;
          it.grams = ng;
          if (ng === 0 && it.auto) m.foods.splice(idx, 1);
        });
      });
    }
  }

  /* ---------- Υδατάνθρακες (§7.3 residual + §9.15 windows) ---------- */
  function windowOf(m, idx) {
    var n = m.name || '';
    if (/post[- ]?workout/i.test(n)) return 'post';
    if (/pre[- ]?workout/i.test(n)) return 'pre';
    if (/κύριο|μετά/i.test(n)) return 'main';
    if (idx === 0) return 'breakfast';
    return 'rest';
  }

  function solveCarbs(meals, dayType, targets, sex, issues, tuneOnly) {
    /* tuneOnly=false: πλήρης κατασκευή (μηδενισμός, post, παράθυρα, fine-tune).
       tuneOnly=true: μόνο αυξητική διόρθωση kcal πάνω στην υπάρχουσα κατάσταση —
       έτσι το iteration συγκλίνει αντί να ταλαντώνεται. */
    var items = [];
    meals.forEach(function (m, i) {
      m.foods.forEach(function (it) {
        var fd = FOODS[it.name];
        if (fd.role !== 'carb') return;
        if (!tuneOnly) it.grams = 0;
        items.push({ it: it, fd: fd, m: m, win: dayType === 'workout' ? windowOf(m, i) : 'flat' });
      });
    });
    if (!items.length) return;

    if (dayType === 'workout') {
      var hasTiming = meals.some(function (m) { return /pre[- ]?workout|post[- ]?workout/i.test(m.name); });
      if (!hasTiming) {
        /* §9.15 trigger: χωρίς Pre/Post ονόματα ο κανόνας δεν εφαρμόζεται — ρώτα τον χρήστη */
        if (!tuneOnly) issues.push({ type: 'timing-unclear',
          note: '§9.15: τα ονόματα γευμάτων δεν δηλώνουν Pre/Post-Workout — ζητείται διευκρίνιση, εφαρμόζεται ισοκατανομή' });
        items.forEach(function (x) { x.win = 'flat'; });
      }
    }

    var flexG;
    if (tuneOnly) {
      flexG = 1;
      items.forEach(function (x) { flexG += x.fd.c * (x.it.grams || 0) / 100; });
    } else {
      var residual = targets.kcal - dayTotals(meals).kcal;
      if (residual <= 0) return; /* δεν χωράνε υδατάνθρακες — θα φανεί στον έλεγχο §11 */
      flexG = residual / 4;
    }

    /* Πίεση πρωτεΐνης: αν οι πρωτεϊνικές τροφές δεν έχουν περιθώριο να «απορροφήσουν»
       την παθητική πρωτεΐνη των carbs (trim στο επόμενο iteration), προτίμησε τροφές
       φτωχές σε πρωτεΐνη (πατάτα/ρύζι/φρούτα αντί βρώμης) ώστε να μην ξεφύγει ο στόχος */
    var trimCap = 0;
    meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        var fd = FOODS[it.name];
        if (fd.locked || fd.role === 'container') return;
        if (fd.role !== 'main' && fd.role !== 'tier2' && fd.role !== 'secondary') return;
        var floor = (fd.role === 'secondary') ? 0 : foodMin(fd, sex);
        trimCap += Math.max(0, (it.grams || 0) - floor) * fd.p / 100;
      });
    });
    /* Σκληρός προϋπολογισμός: πρωτεΐνη που επιτρέπεται να προσθέσουν συνολικά τα carbs =
       όσα μπορούν να επιστρέψουν οι πρωτεϊνικές τροφές (trim) + τρέχον έλλειμμα + ανοχή.
       Στο tune-only mode ΜΟΝΟ το έλλειμμα — αλλιώς ο tuner χαλάει την εξισορρόπηση. */
    var pBudget = (tuneOnly ? 0 : trimCap) + Math.max(0, targets.p - dayTotals(meals).p) + 2;
    var proteinTight = pBudget < flexG * 0.12;
    var byPDensity = function (a, b) { return (a.fd.p / a.fd.kcal) - (b.fd.p / b.fd.kcal); };
    var carbPNow = function () {
      var s = 0;
      items.forEach(function (x) { s += x.fd.p * (x.it.grams || 0) / 100; });
      return s;
    };
    var carbP0 = carbPNow(); /* baseline: το budget αφορά μόνο τη ΜΕΤΑΒΟΛΗ */
    var capByProtein = function (fd, addG) {
      if (fd.p <= 0 || addG <= 0) return addG;
      var room = pBudget - (carbPNow() - carbP0);
      if (room <= 0) return 0;
      return Math.min(addG, Math.floor(room / (fd.p / 100)));
    };

    if (!tuneOnly) {
      /* Post-Workout: 10-20g, γρήγορη απορρόφηση πρώτα (§9.15) */
      var postG = 0;
      var postItems = items.filter(function (x) { return x.win === 'post'; });
      postItems.sort(function (a, b) { return (b.fd.fast ? 1 : 0) - (a.fd.fast ? 1 : 0); });
      postItems.forEach(function (x) {
        if (postG >= 10) return;
        var g = R((15 - postG) / (x.fd.c / 100));
        g = Math.max(x.fd.min, Math.min(x.fd.max, g));
        x.it.grams = g;
        postG += x.fd.c * g / 100;
      });

      /* Στόχοι παραθύρων στους ευέλικτους υδατάνθρακες (30/60/10, ±5% ενδεικτικά) */
      var trainFlex = Math.max(0, 0.60 * flexG - postG);
      var winTarget = {
        breakfast: 0.30 * flexG,
        pre: trainFlex * 0.45,
        main: trainFlex * 0.55,
        rest: 0.10 * flexG,
        flat: flexG
      };
      var fill = function (win) {
        var list = items.filter(function (x) { return x.win === win; });
        if (!list.length) return 0;
        if (proteinTight) list = list.slice().sort(byPDensity);
        var want = win === 'flat' ? winTarget.flat : winTarget[win];
        var remaining = want;
        list.forEach(function (x, k) {
          var share = remaining / (list.length - k);
          var g = R(share / (x.fd.c / 100));
          g = Math.min(x.fd.max, capByProtein(x.fd, g));
          if (g < x.fd.min) g = (g < x.fd.min / 2) ? 0 : x.fd.min;
          x.it.grams = g;
          remaining -= x.fd.c * g / 100;
        });
        return want - remaining;
      };
      ['breakfast', 'pre', 'main', 'rest', 'flat'].forEach(fill);
    }

    /* Fine-tuning kcal ±25: rest → main → breakfast (όχι κάτω από 25% flex) → pre (μόνο αύξηση).
       Το Post-Workout δεν αγγίζεται ποτέ (§9.15). */
    var tuneOrder = ['rest', 'flat', 'main', 'breakfast', 'pre'];
    for (var iter = 0; iter < 30; iter++) {
      var gap = targets.kcal - dayTotals(meals).kcal;
      if (Math.abs(gap) <= 25) break;
      var adjusted = false;
      for (var w = 0; w < tuneOrder.length && Math.abs(gap) > 25; w++) {
        var win = tuneOrder[w];
        if (win === 'pre' && gap < 0) continue; /* ποτέ μείωση Pre-Workout */
        var list = items.filter(function (x) { return x.win === win; });
        if (proteinTight) {
          /* αύξηση: πρώτα οι φτωχές σε πρωτεΐνη · μείωση: πρώτα οι πλούσιες */
          list = list.slice().sort(byPDensity);
          if (gap < 0) list.reverse();
        }
        for (var k = 0; k < list.length && Math.abs(gap) > 25; k++) {
          var x = list[k];
          var cur = x.it.grams || 0;
          var delta = R(gap / (x.fd.kcal / 100));
          if (delta > 0) delta = capByProtein(x.fd, delta);
          var ng = cur + delta;
          ng = Math.min(x.fd.max, ng);
          if (ng < x.fd.min) {
            if (ng < x.fd.min / 2) ng = 0;
            else if (delta > 0 && capByProtein(x.fd, x.fd.min - cur) < x.fd.min - cur) ng = cur;
            else ng = x.fd.min;
          }
          if (win === 'breakfast' && ng < cur) {
            /* floor: το πρωινό κρατά ≥25% των ευέλικτων υδατανθράκων (§9.15) */
            var bNow = 0;
            items.forEach(function (y) { if (y.win === 'breakfast') bNow += y.fd.c * (y.it.grams || 0) / 100; });
            var bAfter = bNow - x.fd.c * (cur - ng) / 100;
            if (bAfter < 0.25 * flexG) continue;
          }
          if (ng !== cur) {
            gap -= (ng - cur) * x.fd.kcal / 100;
            x.it.grams = ng;
            adjusted = true;
          }
        }
      }
      if (!adjusted) break;
    }
  }

  /* ---------- §9.11 feasibility + §10.1 containers (πριν τη λύση) ---------- */
  function preFeasibility(meals, spec, issues) {
    /* §9.11: αν P+F μόνα τους ξεπερνούν το kcal budget, κανένα πλάνο δεν βγαίνει */
    var macroKcal = spec.targets.p * 4 + spec.targets.f * 9;
    if (macroKcal > spec.targets.kcal + 25) {
      issues.push({ type: 'macro-kcal-conflict', macroKcal: R(macroKcal), target: R(spec.targets.kcal),
        suggest: 'Πρωτεΐνη + λιπαρά δίνουν ήδη ' + R(macroKcal) + ' kcal, πάνω από τον στόχο ' +
          R(spec.targets.kcal) + ' kcal — οι στόχοι macros είναι ασύμβατοι μεταξύ τους (§9.11/§9.12).' });
    }
    var lockedKcal = 0, minOtherKcal = 0, maxP = 0, minP = 0, wheyPresent = false;
    var containers = [];
    meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        var fd = FOODS[it.name];
        if (fd.role === 'container') {
          var u = it.units || 1;
          lockedKcal += fd.kcal * u;
          maxP += fd.p * u; minP += fd.p * u;
          containers.push({ name: it.name, kcal: R(fd.kcal * u) });
        } else if (fd.locked) {
          lockedKcal += fd.kcal * (it.grams || fd.locked[0]) / 100;
          maxP += fd.p * (it.grams || fd.locked[0]) / 100;
          minP += fd.p * fd.locked[0] / 100;
        } else if (actsAsMain(it, m)) {
          var mn = foodMin(fd, spec.sex);
          minOtherKcal += fd.kcal * mn / 100;
          minP += fd.p * mn / 100;
          maxP += fd.p * fd.max / 100;
        } else if (fd.role === 'secondary' || fd.role === 'tier2') {
          if (fd.wheyCap) { wheyPresent = true; maxP += fd.p * 45 / 100; }
          else maxP += fd.p * fd.max / 100;
        } else if (fd.role === 'veg' || fd.role === 'extra') {
          minOtherKcal += fd.kcal * foodMin(fd, spec.sex) / 100;
        }
      });
    });
    /* §10.1: containers που δεν χωρούν */
    if (lockedKcal + minOtherKcal > spec.targets.kcal + 25 && containers.length) {
      containers.forEach(function (c) {
        issues.push({ type: 'container-overflow', container: c.name, kcal: c.kcal, target: R(spec.targets.kcal),
          suggest: 'Το ' + c.name + ' προσθέτει ' + c.kcal + ' kcal — ο στόχος είναι ' + R(spec.targets.kcal) +
            ' kcal. α) Αφαίρεσέ το, ή β) μείωσε δραστικά άλλα γεύματα (§10.1).' });
      });
    } else if (lockedKcal + minOtherKcal > spec.targets.kcal + 25) {
      issues.push({ type: 'kcal-infeasible', min: R(lockedKcal + minOtherKcal), target: R(spec.targets.kcal),
        suggest: 'Οι ελάχιστες ποσότητες των τροφών δίνουν ' + R(lockedKcal + minOtherKcal) +
          ' kcal, πάνω από τον στόχο ' + R(spec.targets.kcal) + ' kcal (§9.12). Αφαίρεσε τροφή ή γεύμα.' });
    }
    /* §9.11 πρωτεΐνη: εφικτό εύρος */
    if (!wheyPresent && spec.targets.p > maxP + 3) {
      issues.push({ type: 'protein-infeasible', max: R(maxP), target: R(spec.targets.p),
        suggest: 'Μέγιστη εφικτή πρωτεΐνη ' + R(maxP) + 'g, στόχος ' + R(spec.targets.p) +
          'g (§9.11). Πρόσθεσε πρωτεϊνική τροφή ή γεύμα (§9.12).' });
    }
    if (spec.targets.p < minP - 3) {
      issues.push({ type: 'protein-min-exceeds', min: R(minP), target: R(spec.targets.p),
        suggest: 'Οι ελάχιστες ποσότητες δίνουν ήδη ' + R(minP) + 'g πρωτεΐνη, πάνω από τον στόχο ' +
          R(spec.targets.p) + 'g (§9.12). Αφαίρεσε πρωτεϊνική τροφή ή γεύμα.' });
    }
  }

  /* ---------- Λύση ημέρας με δεδομένες ποσότητες σολομού ---------- */
  function solveDayFixed(spec, mealsInput) {
    var meals = JSON.parse(JSON.stringify(mealsInput));
    var issues = [];

    /* λαχανικά: μετρώνται στα macros στην ελάχιστη μερίδα τους */
    meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        var fd = FOODS[it.name];
        if ((fd.role === 'veg' || fd.role === 'extra') && !it.grams) it.grams = foodMin(fd, spec.sex);
      });
    });

    preFeasibility(meals, spec, issues);

    /* Κατασκευή μία φορά (iter 0), μετά ΜΟΝΟ αυξητικές διορθώσεις — αλλιώς ταλαντώνεται */
    var alloc = allocateProtein(spec.targets.p, meals, spec.sex);
    for (var iter = 0; iter < 20; iter++) {
      if (iter === 0) alloc.flexMeals.forEach(function (m) { fillMealProtein(m, spec.sex); });
      balanceProteinDay(meals, spec.targets, spec.sex, issues);
      enforceMealMinimums(meals, alloc.flexMeals, spec.sex, issues, false);
      solveFats(meals, spec.targets.f, issues);
      solveCarbs(meals, spec.dayType, spec.targets, spec.sex, issues, iter > 0);
      var t = dayTotals(meals);
      if (Math.abs(t.kcal - spec.targets.kcal) <= 25 &&
          Math.abs(t.p - spec.targets.p) <= 3 &&
          Math.abs(t.f - spec.targets.f) <= 3) break;
    }
    /* Τελικό στάδιο με αυστηρή σειρά: (1) boost των hard minimums §9.9,
       (2) εξισορρόπηση ημέρας αν το boost/tuner άφησε την πρωτεΐνη εκτός ±3g
       (το μικρό kcal drift χωράει στο ±25 — η balance σέβεται τα meal minimums),
       (3) αναφορά minimums με τα οριστικά νούμερα. */
    enforceMealMinimums(meals, alloc.flexMeals, spec.sex, issues, false);
    if (Math.abs(dayTotals(meals).p - spec.targets.p) > 3) {
      balanceProteinDay(meals, spec.targets, spec.sex, issues);
      solveFats(meals, spec.targets.f, issues);
    }
    enforceMealMinimums(meals, alloc.flexMeals, spec.sex, issues, true);

    /* κράτα μόνο μία εγγραφή ανά informational type/γεύμα (τα iterations επαναλαμβάνουν) */
    var seen = {};
    issues = issues.filter(function (i) {
      var key = i.type + '|' + (i.meal || '') + '|' + (i.food || '') + '|' + (i.container || '');
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });

    var t = dayTotals(meals);
    var res = {
      ok: true,
      meals: meals.map(function (m) {
        return {
          name: m.name,
          items: m.foods.filter(function (it) {
            return FOODS[it.name].role === 'container' || (it.grams || 0) > 0;
          }).map(function (it) {
            var fd = FOODS[it.name];
            var out = { name: it.name };
            if (fd.role === 'container') out.units = it.units || 1;
            else out.grams = R(it.grams || 0);
            if (it.auto) out.auto = true;
            if (fd.piece && out.grams) out.pieces = Math.round(out.grams / fd.piece * 10) / 10;
            return out;
          }),
          totals: (function (v) { return { kcal: R(v.kcal), p: R(v.p), c: R(v.c), f: R(v.f) }; })(mealTotals(m))
        };
      }),
      totals: { kcal: R(t.kcal), p: R(t.p), c: R(t.c), f: R(t.f) },
      targets: { kcal: R(spec.targets.kcal), p: R(spec.targets.p), f: R(spec.targets.f) },
      diff: { kcal: R(t.kcal - spec.targets.kcal), p: R(t.p - spec.targets.p), f: R(t.f - spec.targets.f) },
      issues: issues
    };
    /* §11 όρια — ρητή αναφορά με πρόταση, ποτέ σιωπηλή υπέρβαση (§9.12).
       Διάγνωση βάσει κατάστασης: αν κάθε διαθέσιμος μοχλός έχει εξαντληθεί,
       το πρόβλημα είναι αδυναμία της σύνθεσης γευμάτων (§9.11), όχι της λύσης. */
    var carbItems = [], carbsMaxed = true, carbsEmpty = true, protAtFloor = true, fatsEmpty = true;
    var minPerMealDiag = spec.sex === 'm' ? 30 : 20;
    meals.forEach(function (m) {
      var mealAtHardMin = mealTotals(m).p <= minPerMealDiag + 2.5;
      m.foods.forEach(function (it) {
        var fd = FOODS[it.name];
        if (fd.role === 'carb') {
          carbItems.push(it);
          if ((it.grams || 0) < fd.max) carbsMaxed = false;
          if ((it.grams || 0) > 0) carbsEmpty = false;
        } else if (fd.role === 'fat') {
          if ((it.grams || 0) > 0) fatsEmpty = false;
        } else if (!fd.locked && fd.role !== 'container' &&
                   (fd.role === 'main' || fd.role === 'tier2' || fd.role === 'secondary')) {
          /* «δάπεδο»: το δικό του min, ή το hard min §9.9 του γεύματος (δεν κόβεται κι άλλο) */
          var floor = (fd.role === 'secondary') ? 0 : foodMin(fd, spec.sex);
          if ((it.grams || 0) > floor && !mealAtHardMin) protAtFloor = false;
        }
      });
    });
    if (!carbItems.length) carbsEmpty = true;
    if (res.diff.kcal < -25 && carbsMaxed) {
      issues.push({ type: 'carb-capacity-infeasible', diff: res.diff.kcal,
        suggest: 'Οι υδατανθρακούχες τροφές είναι στα maximums και λείπουν ' + (-res.diff.kcal) +
          ' kcal — πρόσθεσε υδατανθρακούχα τροφή ή γεύμα (§9.11/§9.12).' });
    } else if (res.diff.kcal > 25 && carbsEmpty) {
      issues.push({ type: 'kcal-floor-conflict', diff: res.diff.kcal,
        suggest: 'Ακόμα και χωρίς καθόλου υδατάνθρακες το πλάνο ξεπερνά τον στόχο κατά ' + res.diff.kcal +
          ' kcal — αφαίρεσε τροφή/container ή γεύμα (§9.12).' });
    } else if (Math.abs(res.diff.kcal) > 25) {
      issues.push({ type: 'kcal-out-of-tolerance', diff: res.diff.kcal,
        suggest: res.diff.kcal > 0 ? 'Αφαίρεσε τροφή/container ή μείωσε γεύμα (§9.12).' : 'Πρόσθεσε υδατανθρακούχα τροφή σε κάποιο γεύμα (§9.12).' });
    }
    if (res.diff.p > 3 && protAtFloor) {
      issues.push({ type: 'protein-floor-conflict', diff: res.diff.p,
        suggest: 'Με τις πρωτεϊνικές τροφές στα ελάχιστά τους η ημέρα έχει ήδη +' + res.diff.p +
          'g πρωτεΐνη πάνω από τον στόχο — αφαίρεσε πρωτεϊνική τροφή ή γεύμα (§9.12).' });
    } else if (Math.abs(res.diff.p) > 3) {
      issues.push({ type: 'protein-out-of-tolerance', diff: res.diff.p,
        suggest: res.diff.p > 0 ? 'Αφαίρεσε πρωτεϊνική τροφή ή γεύμα (§9.12).' : 'Πρόσθεσε πρωτεϊνική τροφή ή γεύμα (§9.12).' });
    }
    if (res.diff.f > 3 && fatsEmpty) {
      issues.push({ type: 'fat-floor-conflict', diff: res.diff.f,
        suggest: 'Τα εγγενή λιπαρά των τροφών ξεπερνούν τον στόχο κατά ' + res.diff.f +
          'g — προτίμησε πιο άπαχη πηγή (π.χ. σολομός 125g, κοτόπουλο αντί μοσχάρι) (§9.12).' });
    } else if (Math.abs(res.diff.f) > 3) {
      issues.push({ type: 'fat-out-of-tolerance', diff: res.diff.f,
        suggest: res.diff.f > 0 ? 'Προτίμησε πιο άπαχη πρωτεϊνική πηγή (π.χ. σολομός 125g αντί 250g) (§9.12).' : 'Πρόσθεσε πηγή λιπαρών (ελαιόλαδο/καρύδια) σε γεύμα (§9.12).' });
    }
    res.withinLimits = !issues.some(function (i) { return /tolerance|infeasible|overflow|under-min|min-exceeds|conflict/.test(i.type); });
    return res;
  }

  /* ---------- Κύριος solver: global επιλογή σολομού §9.1 (125/250) ---------- */
  function solveDay(spec) {
    /* spec: { sex, dayType: 'workout'|'rest', targets:{kcal,p,f}, meals:[{name, foods:[{name, units?}]}] } */
    var issues = [];
    spec.meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        if (!FOODS[it.name]) issues.push({ type: 'unknown-food', food: it.name });
      });
    });
    if (issues.length) return { ok: false, issues: issues };

    /* εντόπισε locked θέσεις σολομού και δοκίμασε όλους τους συνδυασμούς (≤4 λύσεις) */
    var slots = [];
    spec.meals.forEach(function (m, mi) {
      m.foods.forEach(function (it, fi) {
        if (FOODS[it.name].locked) slots.push({ mi: mi, fi: fi });
      });
    });
    var combos = [[]];
    slots.slice(0, 2).forEach(function () {
      var next = [];
      combos.forEach(function (c) {
        next.push(c.concat(125));
        next.push(c.concat(250));
      });
      combos = next;
    });

    var best = null;
    combos.forEach(function (combo) {
      var meals = JSON.parse(JSON.stringify(spec.meals));
      combo.forEach(function (g, k) {
        if (slots[k]) meals[slots[k].mi].foods[slots[k].fi].grams = g;
      });
      var res = solveDayFixed(spec, meals);
      /* §9.1 tie-break: φιλέτο που ξεπερνά το kcal μερίδιο του γεύματος «τρώει» το budget
         της ημέρας (cut χαμηλών θερμίδων → 125g) — ποινή στο σκορ αναλογικά */
      var mealShare = spec.targets.kcal / spec.meals.length;
      var salmonPenalty = 0;
      combo.forEach(function (g) {
        salmonPenalty += Math.max(0, FOODS['Σολωμός'].kcal * g / 100 - mealShare) * 0.5;
      });
      var score = (res.withinLimits ? 0 : 100000) + salmonPenalty +
        Math.abs(res.diff.kcal) + 4 * Math.abs(res.diff.p) + 9 * Math.abs(res.diff.f);
      if (!best || score < best.score) best = { res: res, score: score };
    });
    return best.res;
  }

  window.RLPlan = { FOODS: FOODS, solveDay: solveDay, allocateProtein: allocateProtein, dayTotals: dayTotals };
})();
